import * as React from 'react';
import { lazyLoad } from '../../../utils/loadable';

export const TenantsPage = props => {
  return lazyLoad(
    () => import('./index'),
    module => module.TenantsPage,
    { fallback: <div></div> },
  )(props);
};
